import { Provider } from "@ethersproject/abstract-provider";
import { ethers } from "ethers";
import { abi as ERC20_ABI } from '../../contract_abis/erc20_rw';
import { ContractBase, CurrencyBase, CurrencyWithExchanges, ItemMap, ListOwnedNFTElement, NetworkEnum, TokenDataBase, TokenDataType } from "./commonInterfacesAndEnums";


import assert from "assert";
import { createProvider } from "../../constants/EIP1193";


const SERVICE_TIMEOUT = 20000; // 7.7 seconds


// Promise with timeout 

/**
 * Promise with timeout:
 * - pass a callable that returns promise on call.
 * - timeouts if promise doesn't resolve within the timeout (ms).
 */
export const PromiseWithTimeout = (promise: any, timeoutMs: number, failureMessage?: string) => {
  let timeoutHandle: NodeJS.Timeout;

  const timeoutPromise = new Promise((_resolve, reject) => {
    timeoutHandle = setTimeout(() => reject(new Error(failureMessage)), timeoutMs);
  });

  return Promise.race([
    promise,
    timeoutPromise,
  ]).then((result) => {
    clearTimeout(timeoutHandle);
    return result;
  });
};

export const getTokensOfAddressFromChain = async (
    address: string, walletId: string,
    currencies: CurrencyBase[], tokenDatas: TokenDataBase[],
    contracts: ContractBase[], currencyMap: ItemMap<CurrencyWithExchanges>,
    setTokenData: any, _mergeTokensData: any) => {


  const tokenIdToContractMap: ItemMap<ContractBase> = {};
  const contractIdToContractMap: ItemMap<ContractBase> = {};
  const tokenIdToCurrencyMap: ItemMap<CurrencyWithExchanges> = {};
  const tokenIdToTokenMap: ItemMap<TokenDataBase> = {};
  for (const contract of contracts) {
    // assert that contract.id is exists and is not null
    assert(contract.id != null);

    contractIdToContractMap[contract.id] = contract;
  }
  for (const token of tokenDatas) {
    // assert that token.id is exists and is not null
    assert(token.id != null);

    // assert that token.assetContractId is exists and is not null
    assert(token.assetContractId != null);

    tokenIdToContractMap[token.id] = contractIdToContractMap[token.assetContractId];
    tokenIdToTokenMap[token.id] = token;
  }
  for (const currency of currencies) {
    tokenIdToCurrencyMap[currency.tokenMetadataId] = currencyMap[currency.id];
  }


 tokenDatas.map(async(token: any) => {
    assert(token.id != null);

    const contract = tokenIdToContractMap[token.id];
    const currency = tokenIdToCurrencyMap[token.id];
    const {prov} = createProvider(contract.chain);

    // console.log('==========> api requset', await getBal(prov, token, contract, address, currency), SERVICE_TIMEOUT, `Timeout on chain ${contract.chain}`)

    // LFGG
    const data: any = await getBal(prov, token, contract, address, currency);
    setTokenData(await _mergeTokensData({
        tokens: [{token: tokenIdToTokenMap[data.id], quantity: data.quantity, exchange: data.exchange}],
        contracts: {[token.id]: tokenIdToContractMap[token.id]},
        currencies: [tokenIdToCurrencyMap[data.id]],
      })
    )
  });

  return { contracts: [], tokens: [], tokenIdToCurrencyMap };

}



export const getBal = async (provider: Provider, token: TokenDataBase, contract: ContractBase, address: string, currency: CurrencyWithExchanges) => {

  // console.log(contract.contractAddress, contract.chain, address, currency.decimals);

  let balance;
  if (token.type === TokenDataType.ERC20) {
    balance = await getERC20Balance(provider, contract.contractAddress, contract.chain, address, token.decimals);
  } else if (token.type === TokenDataType.ETH) {
    balance = await fetchNativeBalance(provider, contract.contractAddress, contract.chain, address, token.decimals);
  } else {
    return null;
  }

  for (let index = 0; index < (currency ? currency.exchange.length : 0); index++) {
    const exc = currency.exchange[index];
    const val = parseFloat(ethers.utils.formatUnits(balance.rawBalance.toString(), token.decimals).toString()) * (exc.rate ? exc.rate : 0);
    currency.exchange[index].value = val;
  }

  // console.log("fetch complete for ", token, contract, address);

  return {
    id: token.id,
    assetContractId: contract.id,
    contractAddress: contract.contractAddress,
    quantity: balance.balance,
    exchange: currency ? currency.exchange : [],
  };
}




export const getERC20Balance = async (provider: Provider, contractAddress: string, chain: NetworkEnum, walletAddress: string, decimals: number = 18) => {

  const raContract = new ethers.Contract(contractAddress, ERC20_ABI, provider);
  const balance = await raContract.balanceOf(walletAddress);

  return {
    chain: chain,
    balance: ethers.utils.formatUnits(balance, decimals),
    decimals: decimals,
    rawBalance: balance.toString(),
  };

}



export const fetchNativeBalance = async (provider: Provider, contractAddress: string, chain: NetworkEnum, walletAddress: string, decimals: number = 18) => {

  const balance = await provider.getBalance(walletAddress);

  return {
    balance: ethers.utils.formatUnits(balance, decimals),
    decimals: decimals,
    symbol: TokenDataType.ETH,
    rawBalance: balance,
  };

}



